<template>
  <div class="orderDeposit">
    <div class="box">
      <div class="content">
        <div class="item">
          <div class="title">订单押金</div>
          <span class="text">
            订单押金会根据租期、节假日等动态调整。授权成功后，订单租金由商户通过支付宝向用户支付宝账户发起扣款。
          </span>
        </div>
        <div class="item">
          <div class="title">芝麻信用·免押金</div>
          <span class="text">
            "信用评估"时，芝麻信用以用户信用为担保并授权，最高免除30000元押金，超出部分以"资金授权"形式冻结在支付宝账户。
          </span>
        </div>
        <div class="item">
          <div class="title">支付宝资金授权</div>
          <span class="text">
            支付宝"资金授权"支持用户以余额，余额宝，信用卡，借记卡，花呗以及<span class="black">芝麻信用渠道做预授权</span>：<br/><span class="dot"></span>余额、余额宝：资金冻结；<br/> <span class="dot"></span> 信用卡、借记卡：扣款至支付宝类账户做资金锁定；<br/> <span class="dot"></span>花呗：锁定额度，不产生账期;<br/> <span class="dot"></span>芝麻信用：以用户信用为担保并授权;
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orderDeposit"
}
</script>

<style lang="scss" scoped>
.orderDeposit {
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  .box{
    position: relative;
    z-index: 1000;
    width: 100%;
    background-color: #fff;
    .content {
      padding: 30px;
      box-sizing: border-box;
      .item {
        margin-bottom: 20px;
        .title {
          font-size: 32px;
          margin-bottom: 10px;
          font-weight: bold;
        }
        .text {
          font-size: 28px;
          color: #bbb;
          line-height: 40px;
          .black {
            color: #000;
          }
          .dot {
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: 8px;
            border-radius: 50%;
            background: #bbb;
          }
        }
      }
    }
  }
}
</style>